import { Expose } from 'class-transformer';

export default class ChargeNurseLateCancelFeeError {
    amount: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}